import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const AdminPermission = ({children}) => {
    const role = useSelector(state=>state.login.userInfo.role)

    if(role === 'admin'){
        return children
    }
    toast.error('Право доступу обмежене системним адміністратором!')

    return <Navigate to="/home" />;
};

export default AdminPermission;